<template>
  <div>
    <Login v-if="!isLoggedIn" :onDarkBackground="onDarkBackground" />
    <UserName v-else :onDarkBackground="onDarkBackground" />
  </div>
</template>

<script setup lang="ts">
import Login from '@/components/header/auth/Login.vue'
import UserName from '@/components/header/auth/UserName.vue'
import { useAuthStore } from '@/store/modules/auth'
import { storeToRefs } from 'pinia'

const { isLoggedIn } = storeToRefs(useAuthStore())

withDefaults(defineProps<{ onDarkBackground: boolean }>(), { onDarkBackground: false })
</script>
